import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import { CityObjectActionHistoryType } from "../types/CityObjectActionHistory";

const baseUrl = "/api/CityObjectActionHistory";

export const getHistory = async (
  objectId: number,
  userId: number,
  addressSystemId: number
): Promise<CityObjectActionHistoryType[]> => {
  const token = await getApiAccessToken();
  const response = await apiClient.get<CityObjectActionHistoryType[]>(
    `${baseUrl}/${objectId}?userId=${userId}&addressSystemId=${addressSystemId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};
